import styled from "styled-components";
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from "../../const/colors";

export const Container = styled.div`
  padding-left: 7%;
  padding-right: 7%;
  text-align: end;

  @media screen and (max-width: 1080px) {
    padding-top: 2rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0;
    padding-top: calc(65px + 1rem);
    text-align: center;
  }
`;

export const ContentTitle = styled.div`
  background-color: ${PRIMARY};
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0;
  margin-bottom: 0rem;
  line-height:38px;
  > h2 {
    font-weight: 900;
    color: ${SECONDARY};
  }

  @media screen and (max-width: 768px) {
    padding-left: 1rem;
    margin: 2rem;
    > h2 {
      font-size: 21px;
    }
  }
  @media screen and (max-width: 480px) {
    margin: 1rem;
    h2 {
      font-size: 18px;
    }
  }
`;

export const Form = styled.form`
  text-align: center;
  @media screen and (max-width: 768px) {
    margin: 2rem;
  }
  @media screen and (max-width: 480px) {
    margin: 1rem;
  }
`;
export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: start;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 0.5rem;
  label {
    color: #000;
    font-weight: bold;
    font-size: 1.1rem;
    padding: 0.7rem;
    margin-top: 0.5rem;
    > span {
      color: red;
      margin-left: 0.5rem;
    }
  }
  select, input {
    background-color: transparent;
    border: 1px solid ${PRIMARY};
    padding: 0.7rem;
    color: #000;
    outline: none;
    transition: all 0.3s ease;
    cursor: pointer;
  }
  input {
    color: #000;
    ::placeholder {
      color: #000;
    }
    color-scheme: light;
  }
  input:focus {
    cursor: text;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }

  select:hover, input:hover {
    border-color: #000;
  }
  @media screen and (max-width: 2000px) {
    > label {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    width: 90%;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    input {
      width: 100%;
    }
  }
`;
export const InputContainer2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 0.5rem;
  label {
    color: #000;
    font-weight: bold;
    font-size: 1.1rem;
    padding: 0.7rem;
    margin-top: 0.5rem;
    > span {
      color: red;
      margin-left: 0.5rem;
    }
  }
  select, input {
    background-color: transparent;
    border: 1px solid ${PRIMARY};
    padding: 0.7rem;
    color: #000;
    outline: none;
    transition: all 0.3s ease;
    cursor: pointer;
  }
  input {
    color: #000;
    ::placeholder {
      color: #000;
    }
    color-scheme: dark;
  }
  input:focus {
    cursor: text;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(0);
  }

  select:hover, input:hover {
    border-color: #000;
  }
  
  &.whitetheme{
    label{
      color: #000;
    }
    input {
      color: #000;
      ::placeholder {
        color: #000;
      }
      color-scheme: dark;
    }
    select, input {
      color: #000;
    }
    select:hover, input:hover {
      border-color: #000;
    }
    input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  }

  &.blacktheme{
    label{
      color: #fff;
    }
    input {
      color: #fff;
      
      ::placeholder {
        color: #fff;
      }
      color-scheme: light;
    }
    select, input {
      color: #fff;
    }
    select:hover, input:hover {
      border-color: #fff;
    }
    input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  }
  @media screen and (max-width: 2000px) {
    > label {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    width: 90%;
  }
  @media screen and (max-width: 480px) {
    input {
      width: 100%;
    }
  }
`;

export const Content = styled.div`
  color: #000;
  text-align: start;
  max-height: 400px;
  overflow-y: auto;
  background:${SECONDARY};
  > div {
    padding: 0.7rem 1rem;
    border-bottom: 1px solid ${DARKER};
    font-weight: bold;
  }
  @media screen and (max-width: 768px) {
    width: 90%;
    margin: 0 auto;
    max-width: calc(100vw);
  }
  @media screen and (max-width: 480px) {
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    //max-height: 100%;
    overflow-x: scroll;
    ::-webkit-scrollbar {
      width: 6px;
    }
  }
`

export const Button = styled.button`
  width: 25%;
	font-size: 0.9rem;
  font-weight: bold;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.7rem;
	margin: 2rem 0;
  cursor: pointer;
  transition: all .3s ease-in-out;
  
  &:hover{
    background-color: #000;
     color: ${PRIMARY};
  }

  @media screen and (max-width:  768px) {
    width: 50%;
    //display: none;
  }
`;

export const ButtonBack = styled(Button)`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    margin: 2rem auto;
  }
`

export const Table = styled.table`
  font-size: 0.9rem;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;

  max-width: 100%;
  white-space: wrap;
  td, th {
    text-align: center;
    padding: 12px 8px;
  }

  td {
    font-size: 12px;
    color: #000;
  }

  thead, th {
    color: ${SECONDARY};
    background: ${PRIMARY};
  }
  tbody tr:nth-child(odd) {
    background: gray;
  }
  tbody tr:nth-child(even) {
    background: #E7E2E2;
  }
  &.whitetheme{
  
  }
  &.blacktheme{
  
  }
  @media screen and (max-width: 768px) {
    td.wrap {
      min-width: 170px;
    }
  }
/* @media (max-width: 767px) {
    display: block;
    width: 100%;
   thead, tbody, thead th {
        display: block;
    }
   thead th:last-child{
        border-bottom: none;
    }
   thead {
        float: left;
    }
   tbody {
      width: auto;
      position: relative;
      overflow-x: auto;
    }
   td, th {
      padding: 20px .625em .625em .625em;
      height: 60px;
      vertical-align: middle;
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;
      width: 120px;
      font-size: 13px;
      text-overflow: ellipsis;
    }
   thead th {
      text-align: left;
      border-bottom: 1px solid #f7f7f9;
    }
   tbody tr {
      display: table-cell;
    }
   tbody tr:nth-child(odd) {
    background: ${DARKER};
    }
   tbody tr:nth-child(even) {
    background: ${SECONDARY};
    }
   tr td:nth-child(odd) {
      //background: #F8F8F8;
      //border-right: 1px solid #E6E4E4;
    }
   tr td:nth-child(even) {
      //border-right: 1px solid #E6E4E4;
    }
   tbody td {
      display: block;
      text-align: center;
    }
} */
`;